import { styled } from "@vitality-ds/system";
import { BaseIconButtonWrapper } from "./styles/BaseIconButtonWrapper.styles";

// eslint-disable-next-line import/prefer-default-export
export var IconButtonWrapper = styled("div", BaseIconButtonWrapper);